import { render, staticRenderFns } from "./Agenda.vue?vue&type=template&id=a05eef10"
import script from "./Agenda.vue?vue&type=script&lang=js"
export * from "./Agenda.vue?vue&type=script&lang=js"
import style0 from "./Agenda.vue?vue&type=style&index=0&id=a05eef10&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports